import React from 'react';
import { Stack } from '@balance-web/stack';
import { Box } from '@balance-web/box';
import { Text } from '@balance-web/text';
import { Heading } from '@balance-web/heading';
import { SpotCelebrate } from '@balance-web/illustration';
import { DeprecatedButton } from '@balance-web/button-deprecated';
export type SignUpConfirmationProps = {
  onLoginClick: () => void;
};

export const SignUpConfirmation = ({
  onLoginClick,
}: SignUpConfirmationProps) => {
  return (
    <Stack
      align="center"
      borderRadius="small"
      boxShadow="xsmall"
      gap="large"
      padding="xlarge"
    >
      <Box maxWidth="448px" width="100%">
        <Stack
          align="center"
          gap="medium"
          paddingLeft="xxlarge"
          paddingRight="xxlarge"
        >
          <Heading level="6">Welcome</Heading>

          <SpotCelebrate />

          <Text>Your account has been created.</Text>
          <Stack gap="xxlarge">
            <Text align="center">
              You'll get an email from Reckon. Use the link in the email to
              activate your account.
            </Text>
            <DeprecatedButton
              block
              label="Continue to login"
              onClick={onLoginClick}
            />
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};
